import type { ModuleFile } from '../../core/modules.ts';

// Módulo «connections»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'connections',
    title: 'Conexiones',
    path: 'conexiones',
    nav: { group: 'Sistema', label: 'Conexiones', icon: '⇄', order: 1 },
    load: () => import('./ConnectionsPage.tsx').then((m) => ({ default: m.ConnectionsPage })),
  },
];
